
      import '@folkjs/labs/standalone/folk-space';
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-event-propagator';

      function toggleSpace(event) {
        if (event && event.target !== document.getElementById('main')) return;

        const container = document.getElementById('main');
        const isExpanding = container.classList.contains('circle');
        container.classList.toggle('circle');

        // Get all folk-shapes in the meta space except those inside main
        const shapes = Array.from(document.querySelectorAll('folk-space#meta > folk-shape')).filter(
          (shape) => shape.parentElement.id === 'meta',
        );

        // Get the center point of the main space and viewport dimensions
        const mainRect = container.getBoundingClientRect();
        const centerX = mainRect.left + mainRect.width / 2;
        const centerY = mainRect.top + mainRect.height / 2;

        // Calculate the maximum possible distance (from center to furthest screen corner)
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const maxDistanceX = Math.max(centerX, viewportWidth - centerX);
        const maxDistanceY = Math.max(centerY, viewportHeight - centerY);
        const maxDistance = Math.sqrt(maxDistanceX * maxDistanceX + maxDistanceY * maxDistanceY);

        // Animate each shape
        shapes.forEach((shape) => {
          const rect = shape.getBoundingClientRect();
          const shapeX = rect.left + rect.width / 2;
          const shapeY = rect.top + rect.height / 2;

          // Calculate vector from shape to center
          const dx = centerX - shapeX;
          const dy = centerY - shapeY;
          const currentDistance = Math.sqrt(dx * dx + dy * dy);

          // Calculate the target distance from center
          const circleRadius = 25; // circle is 50px wide so radius is 25
          const minDistance = circleRadius + 50; // 50px from circle edge when contracted
          const maxTargetDistance = maxDistance - 50; // 50px from screen edge when expanded

          const targetDistance = isExpanding ? minDistance : maxTargetDistance;
          const currentTargetDistance = isExpanding ? maxTargetDistance : minDistance;

          // Calculate how far we need to move
          const distanceToMove = targetDistance - currentTargetDistance;

          // Normalize the vector and scale it
          const moveX = (dx / currentDistance) * distanceToMove;
          const moveY = (dy / currentDistance) * distanceToMove;

          // Animate the shape's position
          requestAnimationFrame(() => {
            shape.style.transition = 'all 0.5s ease-in-out';
            shape.x += moveX;
            shape.y += moveY;

            // Remove transition style after animation completes
            const onTransitionEnd = () => {
              shape.style.transition = '';
              shape.removeEventListener('transitionend', onTransitionEnd);
            };
            shape.addEventListener('transitionend', onTransitionEnd);
          });
        });
      }

      // Handle space key press
      document.addEventListener('keydown', (e) => {
        // Only trigger on space if not typing in a contenteditable element
        if (
          e.code === 'Space' &&
          !e.repeat &&
          !(document.activeElement && document.activeElement.hasAttribute('contenteditable'))
        ) {
          e.preventDefault(); // Prevent page scroll
          toggleSpace();
        }
      });

      // Make the toggleSpace function available globally
      window.toggleSpace = toggleSpace;
    